function SidebarPopularSkeleton() {
  return (
    <div className="border rounded-2xl p-4 space-y-4 animate-pulse">
      {/* Title */}
      <div className="h-6 bg-gray-200 rounded w-1/2 mb-2" />

      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="flex gap-3">
          {/* Thumbnail */}
          <div className="w-16 h-16 bg-gray-200 rounded-lg shrink-0" />

          {/* Text */}
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-200 rounded w-full" />
            <div className="h-3 bg-gray-200 rounded w-3/4" />
            <div className="h-3 bg-gray-200 rounded w-1/2" />
          </div>
        </div>
      ))}
    </div>
  );
}
export default SidebarPopularSkeleton;
